<div class="editRoles__container">
  <div class="editRoles__header">
    <div class="editRoles__title">File Extensions</div>
    <div (click)="handleOnClickClose()" class="editRoles__crossIcon">
      <img src="../../../../assets/Images/organisation-structure/Cross.svg" alt="cross icon" />
    </div>
  </div>
  <div class="editRoles__contentWrapper">
    @for (item of preferencesData?.allowedFileTypes
; let index = $index;
      let last = $last
      ; track item) {
      @if (item?.availableExtensions.length > 0) {
        <div [ngClass]="last ? 'no-border' : 'editRoles__cardContainer'">
          <div class="editRolesCard__container">
            <div class="file_types_block">
              @if (item?.status == 'Enabled' && item?.availableExtensions.length > 0) {
                <div class="fileType">{{item?.fileType}}</div>
              }
              @for (extension of item?.availableExtensions; track extension) {
                @if (item?.status == 'Enabled') {
                  <div class="extension-checkbox">
                    <input type="checkbox" [value]="extension"
                      [checked]="item.enabledExtensions.includes(extension)"
                      (change)="updateSelectedExtensions(item, extension)" />
                      {{extension}}
                    </div>
                  }
                }
              </div>
            </div>
          </div>
        }
      }
    </div>
    <div class="editRoles__footer">
      <app-common-button buttonClass="smallbutton" buttonLabel="Cancel"
      (clickEvent)="closePanel.emit(false)"></app-common-button>
      @if (commonService.orgLock() && hasEditAccess) {
        <div>
          <app-common-button buttonClass="smallFilledButton" buttonLabel="Save"   [loadingIcon]="verifyLoader"
          (click)="addFileExtensions()"></app-common-button>
        </div>
      }
    </div>
  </div>
  @if (isToast) {
    <div class="toaster_message" >
      <app-error-toaster  [title]='message'
      (closeToaster)="closeToster()"></app-error-toaster>
    </div>
  }

